import { Box, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { StyledCollapseSidebarButton, StyledLogoContainer } from '../../styles/SidebarStyles'
import Logo from '../Logo/Logo'
import navigation from '../../config/navigation'
import { useAppDispatch } from '../../store/redux/hooks'
import { toggleSidebarState } from '../../store/redux/reducers/sidebarSlice'
import { getCurrentMode } from '../../store/redux/reducers/darkModeSlice'
import { environment } from '../../enviroments/enviroment'
import { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './sidebarConstants'

type SidebarHeaderProps = {
  open: boolean
}

const SidebarHeader = ({ open }: SidebarHeaderProps) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const mode = useSelector(getCurrentMode)
  const dispatch = useAppDispatch()

  const collapseButtonLeft = open ? SIDEBAR_WIDTH - 11 : SIDEBAR_COLLAPSED_WIDTH - 15

  return (
    <Box sx={{ pl: 0 }}>
      <StyledLogoContainer
        sx={{ alignItems: open ? 'flex-start' : 'center', marginLeft: 0, px: open ? 1 : 0 }}
        onClick={() => navigate(navigation.home)}
        aria-label={'Logo, navigate to Dashboard'}
      >
        {open ? <Logo hover /> : <Logo iconVariant hover />}
        <Typography sx={{ cursor: 'pointer' }} variant="caption">
          {environment.version}
        </Typography>
      </StyledLogoContainer>
      <StyledCollapseSidebarButton
        aria-label={open ? 'Collapse sidebar' : 'Expand sidebar'}
        mode={mode}
        onClick={() => dispatch(toggleSidebarState())}
        sx={{
          boxShadow: 2,
          left: collapseButtonLeft,
          transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
        tabIndex={0}
      >
        {open ? <KeyboardDoubleArrowLeft /> : <KeyboardDoubleArrowRight />}
      </StyledCollapseSidebarButton>
    </Box>
  )
}

export default SidebarHeader
